var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8915 20.0004C39.8915 30.9879 30.9845 39.8951 19.9971 39.8951C9.00955 39.8951 0.102478 30.9879 0.102478 20.0004C0.102478 9.01293 9.00955 0.105862 19.9971 0.105862C30.9844 0.105862 39.8915 9.01293 39.8915 20.0004",
    fill: "#00A478"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0075 19.5958C28.0075 18.5908 25.2727 17.7523 21.6386 17.5588L21.6383 15.9574H26.176V12.6248H13.7681V15.9574H18.3054V17.5666C14.7374 17.7734 12.0684 18.6031 12.0684 19.5958C12.0684 20.5887 14.7374 21.4185 18.3054 21.6249V27.3753H21.6383V21.6327C25.2727 21.4397 28.0075 20.6009 28.0075 19.5958ZM20.0379 20.5859C16.1371 20.5859 12.9748 19.9822 12.9748 19.237C12.9748 18.606 15.2424 18.0763 18.3054 17.9289V18.3087H18.3058V19.8651C18.858 19.896 19.4384 19.9123 20.0379 19.9123C20.59 19.9123 21.1261 19.8982 21.6387 19.8725V17.9231C24.7681 18.0615 27.1011 18.5968 27.1011 19.237C27.1011 19.9822 23.9387 20.5859 20.0379 20.5859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/tether.9d2ef87a6eda6379449feef3485bedc5.svg";
export { ForwardRef as ReactComponent };